<template>
  <div>
    <a-input
      v-model:value.trim="inputValue"
      :placeholder="placeholder"
      :maxlength="+maxLength"
      allow-clear
      class="fw"
      :addon-after="addonAfter"
      :disabled="disabled"
    >
      <template #suffix>
        <slot name="suffix"></slot>
      </template>
    </a-input>
    <div class="disabled-cl" v-if="disabled"></div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, ref, watch, getCurrentInstance } from "vue";
import { Form } from "ant-design-vue";
export default defineComponent({
  isGlobal: true,
  name: "TextInput",
  props: {
    value: {
      type: [Number, String],
      default: "",
    },
    placeholder: {
      type: String,
      default: "请输入",
    },
    maxLength: {
      type: [Number, String],
      default: 12,
    },
    addonAfter: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:value", "input"],
  setup(props, { emit }) {
    const formItemContext = Form.useInjectFormItemContext();
    const { proxy } = getCurrentInstance() as any;
    const inputValue = ref<number | string>("");

    const format = (val: string | number, preVal: string | number) => {
      const reg = /^[\u4E00-\u9FA5,.A-Za-z0-9_]+$/;
      val += "";
      if (reg.test(val as string) || val === "") {
        formatValue(val);
      } else {
        formatValue(preVal);
      }

      emit("update:value", inputValue.value);
      emit("input", inputValue.value);
    };

    const formatValue = (value) => {
      if ((inputValue.value + "").length === 0 || (value + "").length === 0) {
        // console.log(inputValue.value,'value:',value);
        inputValue.value = "";
      }
    };

    watch(inputValue, (val, preVal) => {
      format(val, preVal);
      formItemContext.onFieldChange();
    });

    watch(
      () => props.value,
      (n) => {
        //@ts-ignore
        inputValue.value = n;
      },
      {
        immediate: true,
      }
    );

    return {
      inputValue,
    };
  },
});
</script>
<style>
/* to prevent the arrow overflow the popup container,
or the height is not enough when content is empty */
.numeric-input .ant-tooltip-inner {
  min-width: 32px;
  min-height: 37px;
}

.numeric-input .numeric-input-title {
  font-size: 14px;
}
</style>
